'use strict'

if (!Array.prototype.includes) {
	Object.defineProperty(Array.prototype, 'includes', {
		enumerable: false,
		value: function(obj) {
			var newArr = this.filter(function(el) { return el === obj; });
			return newArr.length > 0;
		}
	});
}

export default {};
